import { CONTINUOUS_EDUCATION } from '../../../api/endpoints';
import request from '../../../api/request';

import {
  CeCertificateDetailsInfo,
  CeCertificateFilters,
  CeCertificateFormData,
  CeCertificateStudentsFilters,
  CeCertificateStudentsResponse,
  CeCertificatePaginatedResponse,
  CheckCompletionResponse,
} from './types';

/**
 * Obtiene los datos necesarios para los filtros de certificados
 */
export const getCertificateFormData = () => {
  return request<CeCertificateFormData>(
    CONTINUOUS_EDUCATION.CERTIFICATES_FORM_DATA,
  );
};

/**
 * Obtiene el listado paginado de ofertas para gestión de certificados
 */
export const getCertificateOffers = (filters: CeCertificateFilters = {}) => {
  return request<CeCertificatePaginatedResponse>(
    CONTINUOUS_EDUCATION.CERTIFICATES,
    {
      method: 'GET',
      params: filters,
    },
  );
};

export const getCertificateStudents = (
  ceAcademicOfferId: number,
  filters: CeCertificateStudentsFilters,
) => {
  return request<CeCertificateStudentsResponse>(
    CONTINUOUS_EDUCATION.CERTIFICATES_STUDENTS(ceAcademicOfferId),
    {
      method: 'GET',
      params: { ceAcademicOfferId, ...filters },
    },
  );
};

export const getCertificateDetailsInfo = (ceAcademicOfferId: number) => {
  return request<CeCertificateDetailsInfo>(
    CONTINUOUS_EDUCATION.CERTIFICATES_DETAILS_INFO(ceAcademicOfferId),
    {
      method: 'GET',
    },
  );
};

/**
 * Comprueba y actualiza el estado de finalización de estudiantes
 */
export const checkStudentsCompletion = (
  ceAcademicOfferId: number,
  enrollmentIds?: number[],
) => {
  return request<CheckCompletionResponse>(
    CONTINUOUS_EDUCATION.CERTIFICATE_CHECK_COMPLETION(ceAcademicOfferId),
    {
      method: 'POST',
      data: { enrollmentIds },
    },
  );
};


export const enqueueStudentCertificate = (
  ceAcademicOfferId: number,
  studentId: number,
) => {
  return request<void>(
    CONTINUOUS_EDUCATION.ENQUEUE_STUDENT_CERTIFICATE(),
    { method: 'POST', data: { studentId, ceAcademicOfferId } },
  );
};

